import React from 'react';
import styled from 'styled-components/native';

import { EDataTestId } from '@webtrader/core/constants/test';
import dynamicSize from '@webtrader/core/dynamic-size';
import { useCompany } from '@webtrader/core/services/company';
import { useTheme } from '@webtrader/core/services/theme/v2';

import Button from '@/components/Button';
import FeatherIcons from '@/components/Icons/Feather';
import Text from '@/components/Text';
import { goBack } from '@/utils/navigation';
import { openInAppBrowser } from '@/utils/web';

const PasswordResetSuccessScreen: FCC = () => {
  const { company } = useCompany();
  const { webtraderContactSupportUrl } = company || {};

  const openContactSupport = () => {
    openInAppBrowser(webtraderContactSupportUrl);
  };

  const { theme } = useTheme();

  return (
    <Screen>
      <SuccessPrimary>
        <FeatherIcons name="check-circle" size={60} color={theme.colors.success[0]} />
        <SuccessPrimaryTitle testID={EDataTestId.RESET_PASSWORD_SUCCESS_TITLE}>Help is on the way!</SuccessPrimaryTitle>
        <SuccessPrimaryDescription>
          An email has been sent to your registered account to reset your password. If you have not received it, please
          contact our support team.
        </SuccessPrimaryDescription>
      </SuccessPrimary>
      <SuccessActions>
        <SuccessActionItem>
          <Button onPress={openContactSupport} testID={EDataTestId.RESET_PASSWORD_SUCCESS_CONTACT}>
            Contact Support
          </Button>
        </SuccessActionItem>
        <SuccessActionItem>
          <Button variant="subtle" onPress={goBack} testID={EDataTestId.RESET_PASSWORD_SUCCESS_LOGIN}>
            Back to login screen
          </Button>
        </SuccessActionItem>
      </SuccessActions>
    </Screen>
  );
};

export default PasswordResetSuccessScreen;

const Screen = styled.View`
  flex: 1;
  justify-content: center;

  padding: 0 ${dynamicSize.convertSize(20)}px;

  background-color: ${({ theme }) => theme.colors.background[0]};
`;

const SuccessPrimary = styled.View`
  align-items: center;
`;

const SuccessPrimaryTitle = styled(Text)`
  font-size: ${dynamicSize.convertSize(24)}px;
  font-weight: 500;

  padding-top: ${dynamicSize.convertSize(20)}px;
`;

const SuccessPrimaryDescription = styled(Text)`
  color: ${({ theme }) => theme.colors.text[1]};
  font-size: ${dynamicSize.convertSize(15)}px;
  text-align: center;

  padding-top: ${dynamicSize.convertSize(20)}px;
`;

const SuccessActions = styled.View`
  padding-top: ${dynamicSize.convertSize(30)}px;
`;

const SuccessActionItem = styled.View`
  padding-top: ${dynamicSize.convertSize(10)}px;
`;
